var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 50,
    viewBox: "0 0 174 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4222 15.9477H33.5699V33.1506H49.3381C49.8772 30.6287 50.0599 27.9866 49.8505 25.2821C49.5876 21.9538 48.7455 18.8126 47.4222 15.9477Z",
    fill: "#1ED699"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3458 0.0859037C18.9869 0.192837 17.6547 0.3978 16.367 0.691866V15.9521H47.4222C42.7483 5.81576 32.1263 -0.840852 20.3458 0.0859037Z",
    fill: "#1ED699"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5699 33.1506V15.9477H39.7007C44.9583 15.9477 49.4138 19.9443 49.8416 25.1841C49.8416 25.2153 49.846 25.2509 49.8505 25.2821C50.0643 27.9866 49.8772 30.6287 49.3381 33.1506H33.5699Z",
    fill: "url(#paint0_linear_83_209)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.51469 33.155H16.367V15.9521H0.598804C0.0596815 18.474 -0.123007 21.1161 0.086404 23.8206C0.349282 27.1489 1.19139 30.2901 2.51469 33.155Z",
    fill: "#1ED699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5911 49.0168C30.9501 48.9099 32.2823 48.7049 33.5699 48.4109V33.1506H2.51471C7.18859 43.287 17.8106 49.9436 29.5911 49.0168Z",
    fill: "#1ED699"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2362 33.155C4.97864 33.155 0.52309 29.1584 0.0953564 23.9187C0.0953564 23.883 0.0908921 23.8518 0.0864366 23.8206C-0.12743 21.1161 0.0597141 18.474 0.598836 15.9521H16.367V33.155H10.2362Z",
    fill: "url(#paint1_linear_83_209)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2834 17.1507L94.5379 7.10339H104.781L95.3711 41.9948H84.3926L82.2361 31.6535C81.2247 26.7212 80.4405 22.4751 79.8836 18.9106C79.2643 22.7647 78.4623 27.0153 77.4821 31.6535L75.3256 41.9948H64.3471L54.937 7.10339H65.1803L67.4348 17.1507C68.8739 23.5221 69.8542 28.1782 70.3755 31.1188C71.1285 26.5474 71.9928 21.8914 72.973 17.1507L75.0315 7.10339H84.6867L86.7452 17.1507C87.7254 21.8869 88.5898 26.543 89.3428 31.1188C89.8997 28.1782 90.8799 23.5221 92.2834 17.1507Z",
    fill: "#232222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.323 23.2771C133.119 23.932 134.567 25.0415 135.658 26.6098C136.754 28.1782 137.302 29.8757 137.302 31.707C137.302 34.9729 136.197 37.5081 133.996 39.3037C131.791 41.0993 128.516 41.9993 124.172 41.9993H106.483V7.10785H123.833C128.079 7.10785 131.149 7.95886 133.047 9.65643C134.941 11.354 135.89 13.4615 135.89 15.9789C135.89 19.4408 134.371 21.878 131.332 23.2815L131.323 23.2771ZM123.138 14.7491H116.277V20.7285H123.138C124.381 20.8265 125.255 20.3542 125.758 19.3072C126.266 18.2601 126.266 17.2175 125.758 16.1704C125.25 15.1234 124.377 14.6511 123.138 14.7491ZM116.277 34.3001H123.628C125.981 34.3001 127.157 33.2397 127.157 31.1144C127.157 28.9891 125.981 27.9286 123.628 27.9286H116.277V34.3001Z",
    fill: "#232222"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M155.895 42.7791C150.473 42.7791 146.142 41.1305 142.907 37.8289C139.642 34.563 138.006 30.1342 138.006 24.5469C138.006 18.9596 139.606 14.5175 142.809 11.2159C145.977 7.94998 150.339 6.31479 155.895 6.31479C160.369 6.31479 164.192 7.52224 167.364 9.9416C170.465 12.3922 172.345 15.7739 173 20.0869H163.1C162.641 18.3537 161.777 17.0259 160.502 16.0947C159.228 15.1635 157.691 14.7001 155.895 14.7001C153.378 14.7001 151.467 15.5511 150.161 17.2487C148.856 18.9463 148.201 21.3835 148.201 24.5514C148.201 27.7193 148.856 30.1565 150.161 31.854C151.467 33.5516 153.378 34.4026 155.895 34.4026C157.856 34.4026 159.482 33.8724 160.77 32.812C162.062 31.7516 162.886 30.2545 163.243 28.3297H173.045C172.488 32.9055 170.661 36.4477 167.556 38.9651C164.419 41.5137 160.529 42.788 155.891 42.788L155.895 42.7791Z",
    fill: "#232222"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_83_209",
    x1: 41.7547,
    y1: 33.1506,
    x2: 41.7547,
    y2: 15.9477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ED699"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_83_209",
    x1: 8.18218,
    y1: 33.155,
    x2: 8.18218,
    y2: 15.9521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#119364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ED699"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ce2c749586ed22f09bd14f7a72fbaa97.svg";
export { ForwardRef as ReactComponent };